import * as z from "zod";

export const requestEmailOtp = {
  name: "requestEmailOtp" as const,
  input: z.object({
    email: z.string(),
    next: z.string().optional(),
    isMobile: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean(), otpId: z.string().optional() }),
};
